module.exports = __webpack_public_path__ + "a21bbe9fc09470179be3d127192e6eea.pdf";